import {Order, Store} from 'aigens-ng-core';

export class Session {
    code: string;
    order: Order;
    date: string;
    store: Store;
}
